function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagMW(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURd8dNdcaMUGtQ0W0R88XLT2mPxgYGCUjIx4eHhAQEDqgPJUaKUGW3OwAAAFvSURBVDjL3Y+xasMwEIbPU1YbvHUpMtqL+wIR6AGCwUsnT4q9tUvrMZOdMZOK6ZIli6cMhdC3693JduzSmEAhQz+i0393nwWBt3me4e/Ctq635XagrstynDfgMg7LQaRP+qYXLrIBk+dVVeWIqfL151KfDKWKMMZkQBVHpqL9EZATNQw6GZgRL8C8jkYTYe32sJgItiksnqaxtnsAn7DDdAcc8FcUzbEXvlDHibW2yKAZeO/3sDgPdyPhAwKPAP/ugtCtA28i/AM8gOAM/kG+PYrdyAeXcce3x5LHiaM/fuE3fgpKUQ1dprIEHTJaK0xKYeIaKl5oH0Lc4NYtcKpp1elaKXoB93QmuAF+isI8VwiP8zzcQhAiEnHcHyFEHNEVxzQQ4h4EDQXXWHSOq5GIogiFeQYhmdyy6yQKaZKkMqUfJ8k1SVPupVwBZykThDXqKUlnrSCd5wqhJQ6H9omOy31HZw8U2jPjTOyhnWf/DSLPjisLzjA5AAAAAElFTkSuQmCC",
    alt: "MW"
  }, props));
}